import {
  Box,
  FormControl,
  TextField,
  TextFieldProps,
  Tooltip,
} from "@mui/material";
import { blockInvalidChar } from "utils/common";
import { InfolconIcon } from "./Icons";

interface GKTextFieldProps {
  inputLabel?: string;
  requiredField?: boolean;
  loading?: boolean;
  blockChar?: boolean;
  tooltipTitle?: string;
  placeholder?: string;
}

const GKTextArea = (props: GKTextFieldProps & TextFieldProps) => {
  const {
    inputLabel,
    id,
    name,
    loading,
    requiredField,
    type,
    placeholder,
    fullWidth = true,
    tooltipTitle,
    blockChar = true,
    slotProps,
    disabled,
  } = props;

  return (
    <FormControl variant="standard" fullWidth={fullWidth}>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <TextField
          {...props}
          multiline
          rows={4}
          id={id}
          fullWidth
          name={name}
          label={inputLabel}
          type={type || ""}
          disabled={disabled || loading}
          placeholder={placeholder || inputLabel || "Enter"}
          onKeyDown={(e) => blockChar && blockInvalidChar(e)}
          onWheel={(e: any) => e.target.blur()}
          sx={{
            ...props.sx,
            mt: inputLabel ? 0.7 : 0,
          }}
          slotProps={{
            ...slotProps,
            input: {
              ...slotProps?.input,
              autoComplete: "off",
              sx: {
                borderRadius: 2,
              },
            },
            inputLabel: {
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                  marginRight: 0,
                },
              },
            },
          }}
        />
        {tooltipTitle && (
          <Tooltip title={tooltipTitle} arrow>
            <InfolconIcon />
          </Tooltip>
        )}
      </Box>
    </FormControl>
  );
};

export default GKTextArea;
